<template>
    <main class="offers-container">
        <h2>{{translate("accessories")}}</h2>
        <div class="accessory-panel">
            <additional_accesories></additional_accesories>
            <accessories_in_price></accessories_in_price>
        </div>
        <div class="summary-order">
            <div>
                <p><span>{{translate("fan_price")}}: </span>
                    <span v-if="getFanCount > 1">
                        {{getFanCount}} x
                    </span>
                    <span v-html="$priceController.convertWithThousandSeparator(calculateDiscount(parseFloat(getActiveFanPrice / getFanCount)))"></span>
                    <span> Euro</span></p>
                <p><span>{{translate("price_additional_accessories")}}: </span><span
                        v-html="$priceController.convertWithThousandSeparator(parseFloat(parseFloat(getAccessories.sumAdditionalAccessoriesPrice) * parseInt(getFanCount)).toFixed(2))"></span><span> Euro</span></p>
                <p class="summary-sum"><span>{{translate("summary_price")}}: </span><span>{{ this.calcSubtotal() }}</span><span> Euro</span>
                </p>
            </div>
        </div>
        <div class="form-other-information">
            <other_information></other_information>
        </div>
    </main>
</template>

<script>
    import Additional_accesories from "../components/offers/additional_accesories";
    import Accessories_in_price from "../components/offers/accessories_in_price";
    import Other_information from "../components/offers/other_information";

    export default {
        name: "SelectionOfTheOffer",
        components: {Other_information, Accessories_in_price, Additional_accesories},
        data() {
            return {
                additionalAccesories: {},
                includedAccesories: {}
            }
        },

        computed: {
            getAccessories() {
                return this.$store.state.productCard.custom.accesories;
            },

            getActiveFanPrice() {
                return this.$store.state.activeFun.params.price;
            },

            getActiveEnginePrice() {
                let idPrice = this.$store.state.activeFun.engine.id_price;
                let price = this.$store.state.pricesList.find(x => x.id === idPrice);
                if(price !== undefined) {
                    return price.constant;
                } else {
                    return 0;
                }
            },

            getFanCount() {
                return this.$store.state.workPointParameters.elements.number_of_fans.value;
            }
        },

        methods: {
            calcSubtotal(){
                let fanPrice = parseFloat(this.calculateDiscount(this.getActiveFanPrice));
                let subtotalAccesories = parseFloat(this.getAccessories.sumAdditionalAccessoriesPrice * this.getFanCount);
                let subtotal = fanPrice + subtotalAccesories;

                return this.$priceController.convertWithThousandSeparator(parseFloat(subtotal).toFixed(2).toString());
            },

            calculateDiscount(price){
                price = parseFloat(price);
                return parseFloat(this.$priceController.calculateDiscount(price, this.$store.state.discount)).toFixed(2);
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            calculateFormulaPrice(priceObject) {
                if (priceObject) {
                    return (this.getActiveFanPrice * parseFloat(priceObject.fan_ratio)) + (this.getActiveEnginePrice * parseFloat(priceObject.motor_ratio)) + parseFloat(priceObject.constant);
                }
            },
        },

        created() {
            if (!this.$store.state.productCard.custom.accesories.isStored) {

                //VERSION SEPARATION
                let currentVersion = this.$store.state.activeFun.params.version.version_id;
                let standardVersion = this.$store.state.activeFun.params.standardVersion.version_id;

                //SET STORED FLAG
                this.$store.state.productCard.custom.accesories.isStored = true;

                this.$store.state.productCard.custom.accesories.sumAdditionalAccessoriesPrice = 0;

                if (currentVersion && standardVersion) {
                    let additionalExtras = [];
                    let includedExtras = [];
                    let dedicatedExtras = [];

                    let standardExtras = [];

                    this.$store.state.relationsVersionsExtras.forEach((version) => {
                        if (version.id_fan_version === currentVersion) {
                            dedicatedExtras.push(version);
                        }

                        if (version.id_fan_version === standardVersion) {
                            standardExtras.push(version);
                        }
                    });

                    let counter = 0;
                    dedicatedExtras.forEach(function (extra) {
                        let storedExtra = this.$store.state.fansExtrasList.find(x => x.id === extra.id_extra);
                        if (storedExtra !== undefined) {
                            let extraPrice = this.$store.state.pricesList.find(price => price.id === extra.id_price);
                            let extraStandardPrice = this.$store.state.pricesList.find(price => price.id === standardExtras[counter].id_price);
                            if (extraPrice !== undefined) {
                                let extraObject = {
                                    title: storedExtra.name_translation_code,
                                    price: extraPrice.constant,
                                    isActive: false,
                                    id: storedExtra.id,
                                    image: storedExtra.image,
                                    is_image_visible: storedExtra.is_image_visible,
                                    type: extraStandardPrice.type,
                                };

                                if (extraPrice.type === 'inPrice') {
                                    includedExtras.push(extraObject);
                                } else if (extraPrice.type === 'static') {
                                    additionalExtras.push(extraObject);
                                } else if (extraPrice.type === 'formula') {
                                    extraObject.price = this.calculateFormulaPrice(extraPrice);
                                    additionalExtras.push(extraObject);
                                } else if (extraPrice.type === 'standard') {
                                    extraObject.price = extraStandardPrice.constant;
                                    if (extraStandardPrice.type === 'inPrice') {
                                        includedExtras.push(extraObject);
                                    } else if (extraStandardPrice.type === 'static') {
                                        additionalExtras.push(extraObject);
                                    } else if (extraStandardPrice.type === 'formula') {
                                        extraObject.price = this.calculateFormulaPrice(extraStandardPrice);
                                        additionalExtras.push(extraObject);
                                    }
                                }
                            }
                        }
                        counter++;
                    }.bind(this));

                    for (let extra of includedExtras) {
                        extra['isActive'] = true;
                    }

                    this.$store.state.productCard.custom.accesories.values.add_accessories.values = additionalExtras;
                    this.$store.state.productCard.custom.accesories.values.included_accessories.values = includedExtras;

                    this.additionalAccesories = additionalExtras;
                    this.includedAccesories = includedExtras;
                }
            }
        }
    }
</script>

<style scoped>
</style>
